import { SecureStoragePlugin } from 'capacitor-secure-storage-plugin';

export const setMobileHeaders = async axios => {
  // This value is set by webpack.config.ts in mobile-app
  const baseUrl = await SecureStoragePlugin.get({ key: 'BASE_API_URL' });
  const whitelabelSubdomain = await SecureStoragePlugin.get({
    key: 'WHITELABEL_SUBDOMAIN'
  });
  const baseUAPIUrl = await SecureStoragePlugin.get({ key: 'BASE_UAPI_URL' });
  if (baseUAPIUrl?.value) {
    // @ts-expect-error in the off chance window.process isn't defined, we only care about adding env to it
    window.process = window.process || {};
    window.process.env = window.process.env || {};
    window.process.env.VW_UNIFIED_API_URL = baseUAPIUrl.value;
  }

  axios.defaults.baseURL = baseUrl?.value;
  axios.defaults.headers.common['x-mobile-subdomain'] =
    whitelabelSubdomain?.value;
  return axios;
};
